import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h3", null, "Begin Token Refresh", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", null, " Welcome to the EnableWA Campfire Integration self-service token refresh tool. ", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", null, " This tool allows any EnableWA staff member with the required access in the Employment Hero system to reconnect the Campfire integration in the event that the tokens in stored Campfire become expired or invalid. ", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", null, " To complete a refresh, simply follow the prompts to authorise the application with Employment Hero. ", -1)
const _hoisted_5 = { style: {"margin-top":"25px"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_button = _resolveComponent("van-button")!
  const _component_van_col = _resolveComponent("van-col")!
  const _component_van_row = _resolveComponent("van-row")!

  return (_openBlock(), _createElementBlock("div", null, [
    _hoisted_1,
    _hoisted_2,
    _hoisted_3,
    _hoisted_4,
    _createElementVNode("p", _hoisted_5, [
      _createVNode(_component_van_row, null, {
        default: _withCtx(() => [
          _createVNode(_component_van_col, {
            span: "12",
            offset: "12"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_van_row, { justify: "end" }, {
                default: _withCtx(() => [
                  _createVNode(_component_van_col, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_van_button, {
                        type: "primary",
                        onClick: _ctx.clickContinueButton,
                        loading: _ctx.nextButtonLoading,
                        disabled: _ctx.nextButtonDisabled
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(" Continue ")
                        ]),
                        _: 1
                      }, 8, ["onClick", "loading", "disabled"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ])
  ]))
}